export default "__VITE_ASSET__380c870c__"